// UGC Public Self-Disclosure structure.
//
// Each item is either:
//   path  -> a page that already exists on this website (or an external site)
//   code  -> a document list uploaded from superadmin (UGC Self Disclosure tab)
//
// Keep the `code` values in sync with superadmin/src/Components/Ugc/UgcForm.js
export const sections = [
  {
    title: "About HEI",
    link: "about-hei",
    items: [
      { title: "About Us - Overview", path: "/aboutus/about" },
      { title: "History", path: "/aboutus/history" },
      { title: "Vision & Mission", path: "/aboutus/vision" },
      { title: "Institutional Development Plan (IDP)", path: "/iqac/idp" },
      { title: "Annual Report of the College", path: "/iqac/annual-report" },
      { title: "Audit Report", path: "/iqac/auditreport" },
      { title: "NAAC", code: "UGC_NAAC" },
      { title: "UGC 2(f) & 12(B) Status", code: "UGC_2F_12B" },
      {
        title:
          "Annual Accounts - Balance Sheet, Income & Expenditure, Receipt & Payment",
        code: "UGC_ANNUAL_ACCOUNTS",
      },
      { title: "Sponsoring Body Details", code: "UGC_SPONSORING_BODY" },
      { title: "Formal Undertaking", code: "UGC_FORMAL_UNDERTAKING" },
    ],
  },
  {
    title: "Administrative Profiles",
    link: "administrative-profiles",
    items: [
      { title: "Principal", path: "/administrations/principal" },
      { title: "Governing Body", path: "/administrations/gb" },
      { title: "IQAC", path: "/iqac/about" },
      { title: "Office Staff", path: "/administrations/officestaff" },
      { title: "Organogram", path: "/administrations/organogram" },
    ],
  },
  {
    title: "Academics",
    link: "academics",
    items: [
      { title: "Academic Programmes", path: "/departments" },
      { title: "Courses & Syllabus", path: "/syllabus-course" },
      { title: "Academic Calendar", path: "/iqac/academic-calendar" },
      {
        title: "Departments with Faculty & Staff Profiles",
        path: "/departments",
      },
      { title: "IQAC", path: "/iqac/about" },
      { title: "Library", path: "/facility/library" },
      {
        title: "Academic Collaborations (MoUs)",
        path: "/iqac/mou-collaborations",
      },
    ],
  },
  {
    title: "Admission & Fee",
    link: "admission-and-fee",
    items: [
      { title: "Prospectus", path: "/notifications/prospectus" },
      { title: "Admission Process & Guidelines", path: "/admissionprocedure" },
      { title: "Admission Helpdesk", path: "/admission-helpdesk" },
      { title: "Fee Refund Policy", code: "UGC_FEE_REFUND_POLICY" },
    ],
  },
  {
    title: "Research",
    link: "research",
    items: [
      { title: "Research Publications", path: "/research" },
      { title: "Research Projects", path: "/research-projects" },
      { title: "Research Journal", path: "/research-journal" },
      {
        title: "Research & Development Cell",
        code: "UGC_RESEARCH_DEVELOPMENT_CELL",
      },
    ],
  },
  {
    title: "Student Life",
    link: "student-life",
    items: [
      { title: "NCC", path: "/ncc/home" },
      { title: "NSS", path: "/nss/home" },
      { title: "Hostel", path: "/facility/girlshostel" },
      {
        title: "Career Guidance & Placement Cell",
        path: "/facility/Career_Placement_Cell",
      },
      { title: "Student's Union (RCSU)", path: "/students/students_union" },
      { title: "Student Clubs", path: "/students/clubs" },
      { title: "Anti-Ragging", path: "/facility/antiragging" },
      { title: "Disability Support", path: "/facility/disability_support" },
      {
        title: "Student Grievance Redressal Committee",
        code: "UGC_SGRC",
      },
      { title: "Internal Complaints Committee", code: "UGC_ICC" },
      {
        title: "Socio-Economically Disadvantaged Groups",
        code: "UGC_SEDG",
      },
      {
        title: "Accessibility Guidelines",
        code: "UGC_ACCESSIBILITY_GUIDELINES",
      },
    ],
  },
  {
    title: "Alumni",
    link: "alumni",
    items: [
      { title: "Alumni Association", path: "/alumni/committee" },
      { title: "Alumni Members", path: "/alumni/list" },
      { title: "Prominent Alumni", path: "/alumni/prominent" },
      { title: "Alumni Registration", path: "/alumni-registration" },
    ],
  },
  {
    title: "RTI / Reservation Roster / Job Openings",
    link: "rti-roster-jobs",
    items: [
      { title: "Right to Information (RTI)", path: "/rti/home" },
      { title: "Members of the RTI Cell", path: "/rti/officers" },
      { title: "Reservation Roster", code: "UGC_RESERVATION_ROSTER" },
      { title: "Job Openings / Recruitment", path: "/recruitment" },
    ],
  },
  {
    title: "Picture Gallery",
    link: "picture-gallery",
    items: [
      { title: "Photo Gallery", path: "/gallery/photo" },
      { title: "Video Gallery", path: "/gallery/video" },
      { title: "Document Gallery", path: "/gallery/document" },
    ],
  },
  {
    title: "Contact Details",
    link: "contact-details",
    items: [
      { title: "Contact Us", path: "/contactus" },
      {
        title: "Grievance Redressal Portal",
        path: "https://grievance.rangiacollege.ac.in/",
        external: true,
      },
    ],
  },
];

export default sections;
